var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35929 15.3334C1.87712 15.3334 1.47453 15.1757 1.15152 14.8605C0.8285 14.5453 0.666992 14.1524 0.666992 13.6819V11.244H1.71461V13.6819C1.71461 13.8392 1.78176 13.9833 1.91607 14.1144C2.05039 14.2455 2.19813 14.311 2.35929 14.311H13.6414C13.8025 14.311 13.9503 14.2455 14.0846 14.1144C14.2189 13.9833 14.286 13.8392 14.286 13.6819V11.244H15.3337V13.6819C15.3337 14.1524 15.1722 14.5453 14.8491 14.8605C14.5261 15.1757 14.1235 15.3334 13.6414 15.3334H2.35929ZM8.00033 11.4799L4.29335 7.86239L5.03475 7.12709L7.47652 9.50994V0.666687H8.52413V9.50994L10.9659 7.12709L11.7073 7.86239L8.00033 11.4799Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.d805c0417cf6dc91afc188c3b275c448.svg";
export { ForwardRef as ReactComponent };